import { render, staticRenderFns } from "./ModalBenefit.vue?vue&type=template&id=4d0527c0&scoped=true&"
import script from "./ModalBenefit.vue?vue&type=script&lang=js&"
export * from "./ModalBenefit.vue?vue&type=script&lang=js&"
import style0 from "./ModalBenefit.vue?vue&type=style&index=0&id=4d0527c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0527c0",
  null
  
)

export default component.exports